
export interface Country {
    code: string;
    name: string;
    translationKey: string;
}

// Base country data with translation keys
export const COUNTRIES: Country[] = [
    { code: 'AF', name: 'Afghanistan', translationKey: 'COUNTRY_AF' },
    { code: 'AX', name: 'Åland Islands', translationKey: 'COUNTRY_AX' },
    { code: 'AL', name: 'Albania', translationKey: 'COUNTRY_AL' },
    { code: 'DZ', name: 'Algeria', translationKey: 'COUNTRY_DZ' },
    { code: 'AS', name: 'American Samoa', translationKey: 'COUNTRY_AS' },
    { code: 'AD', name: 'Andorra', translationKey: 'COUNTRY_AD' },
    { code: 'AO', name: 'Angola', translationKey: 'COUNTRY_AO' },
    { code: 'AI', name: 'Anguilla', translationKey: 'COUNTRY_AI' },
    { code: 'AQ', name: 'Antarctica', translationKey: 'COUNTRY_AQ' },
    { code: 'AG', name: 'Antigua and Barbuda', translationKey: 'COUNTRY_AG' },
    { code: 'AR', name: 'Argentina', translationKey: 'COUNTRY_AR' },
    { code: 'AM', name: 'Armenia', translationKey: 'COUNTRY_AM' },
    { code: 'AW', name: 'Aruba', translationKey: 'COUNTRY_AW' },
    { code: 'AU', name: 'Australia', translationKey: 'COUNTRY_AU' },
    { code: 'AT', name: 'Austria', translationKey: 'COUNTRY_AT' },
    { code: 'AZ', name: 'Azerbaijan', translationKey: 'COUNTRY_AZ' },
    { code: 'BS', name: 'Bahamas', translationKey: 'COUNTRY_BS' },
    { code: 'BH', name: 'Bahrain', translationKey: 'COUNTRY_BH' },
    { code: 'BD', name: 'Bangladesh', translationKey: 'COUNTRY_BD' },
    { code: 'BB', name: 'Barbados', translationKey: 'COUNTRY_BB' },
    { code: 'BY', name: 'Belarus', translationKey: 'COUNTRY_BY' },
    { code: 'BE', name: 'Belgium', translationKey: 'COUNTRY_BE' },
    { code: 'BZ', name: 'Belize', translationKey: 'COUNTRY_BZ' },
    { code: 'BJ', name: 'Benin', translationKey: 'COUNTRY_BJ' },
    { code: 'BM', name: 'Bermuda', translationKey: 'COUNTRY_BM' },
    { code: 'BT', name: 'Bhutan', translationKey: 'COUNTRY_BT' },
    { code: 'BO', name: 'Bolivia', translationKey: 'COUNTRY_BO' },
    { code: 'BA', name: 'Bosnia and Herzegovina', translationKey: 'COUNTRY_BA' },
    { code: 'BW', name: 'Botswana', translationKey: 'COUNTRY_BW' },
    { code: 'BV', name: 'Bouvet Island', translationKey: 'COUNTRY_BV' },
    { code: 'BR', name: 'Brazil', translationKey: 'COUNTRY_BR' },
    { code: 'IO', name: 'British Indian Ocean Territory', translationKey: 'COUNTRY_IO' },
    { code: 'VG', name: 'British Virgin Islands', translationKey: 'COUNTRY_VG' },
    { code: 'BN', name: 'Brunei', translationKey: 'COUNTRY_BN' },
    { code: 'BG', name: 'Bulgaria', translationKey: 'COUNTRY_BG' },
    { code: 'BF', name: 'Burkina Faso', translationKey: 'COUNTRY_BF' },
    { code: 'BI', name: 'Burundi', translationKey: 'COUNTRY_BI' },
    { code: 'KH', name: 'Cambodia', translationKey: 'COUNTRY_KH' },
    { code: 'CM', name: 'Cameroon', translationKey: 'COUNTRY_CM' },
    { code: 'CA', name: 'Canada', translationKey: 'COUNTRY_CA' },
    { code: 'CV', name: 'Cape Verde', translationKey: 'COUNTRY_CV' },
    { code: 'KY', name: 'Cayman Islands', translationKey: 'COUNTRY_KY' },
    { code: 'CF', name: 'Central African Republic', translationKey: 'COUNTRY_CF' },
    { code: 'TD', name: 'Chad', translationKey: 'COUNTRY_TD' },
    { code: 'CL', name: 'Chile', translationKey: 'COUNTRY_CL' },
    { code: 'CN', name: 'China', translationKey: 'COUNTRY_CN' },
    { code: 'CX', name: 'Christmas Island', translationKey: 'COUNTRY_CX' },
    { code: 'CC', name: 'Cocos (Keeling) Islands', translationKey: 'COUNTRY_CC' },
    { code: 'CO', name: 'Colombia', translationKey: 'COUNTRY_CO' },
    { code: 'KM', name: 'Comoros', translationKey: 'COUNTRY_KM' },
    { code: 'CG', name: 'Congo', translationKey: 'COUNTRY_CG' },
    { code: 'CD', name: 'Congo (Democratic Republic)', translationKey: 'COUNTRY_CD' },
    { code: 'CK', name: 'Cook Islands', translationKey: 'COUNTRY_CK' },
    { code: 'CR', name: 'Costa Rica', translationKey: 'COUNTRY_CR' },
    { code: 'HR', name: 'Croatia', translationKey: 'COUNTRY_HR' },
    { code: 'CU', name: 'Cuba', translationKey: 'COUNTRY_CU' },
    { code: 'CY', name: 'Cyprus', translationKey: 'COUNTRY_CY' },
    { code: 'CZ', name: 'Czech Republic', translationKey: 'COUNTRY_CZ' },
    { code: 'DK', name: 'Denmark', translationKey: 'COUNTRY_DK' },
    { code: 'DJ', name: 'Djibouti', translationKey: 'COUNTRY_DJ' },
    { code: 'DM', name: 'Dominica', translationKey: 'COUNTRY_DM' },
    { code: 'DO', name: 'Dominican Republic', translationKey: 'COUNTRY_DO' },
    { code: 'TL', name: 'East Timor', translationKey: 'COUNTRY_TL' },
    { code: 'EC', name: 'Ecuador', translationKey: 'COUNTRY_EC' },
    { code: 'EG', name: 'Egypt', translationKey: 'COUNTRY_EG' },
    { code: 'SV', name: 'El Salvador', translationKey: 'COUNTRY_SV' },
    { code: 'GQ', name: 'Equatorial Guinea', translationKey: 'COUNTRY_GQ' },
    { code: 'ER', name: 'Eritrea', translationKey: 'COUNTRY_ER' },
    { code: 'EE', name: 'Estonia', translationKey: 'COUNTRY_EE' },
    { code: 'ET', name: 'Ethiopia', translationKey: 'COUNTRY_ET' },
    { code: 'FK', name: 'Falkland Islands', translationKey: 'COUNTRY_FK' },
    { code: 'FO', name: 'Faroe Islands', translationKey: 'COUNTRY_FO' },
    { code: 'FJ', name: 'Fiji', translationKey: 'COUNTRY_FJ' },
    { code: 'FI', name: 'Finland', translationKey: 'COUNTRY_FI' },
    { code: 'FR', name: 'France', translationKey: 'COUNTRY_FR' },
    { code: 'GF', name: 'French Guiana', translationKey: 'COUNTRY_GF' },
    { code: 'PF', name: 'French Polynesia', translationKey: 'COUNTRY_PF' },
    { code: 'TF', name: 'French Southern Territories', translationKey: 'COUNTRY_TF' },
    { code: 'GA', name: 'Gabon', translationKey: 'COUNTRY_GA' },
    { code: 'GM', name: 'Gambia', translationKey: 'COUNTRY_GM' },
    { code: 'GE', name: 'Georgia', translationKey: 'COUNTRY_GE' },
    { code: 'DE', name: 'Germany', translationKey: 'COUNTRY_DE' },
    { code: 'GH', name: 'Ghana', translationKey: 'COUNTRY_GH' },
    { code: 'GI', name: 'Gibraltar', translationKey: 'COUNTRY_GI' },
    { code: 'GR', name: 'Greece', translationKey: 'COUNTRY_GR' },
    { code: 'GL', name: 'Greenland', translationKey: 'COUNTRY_GL' },
    { code: 'GD', name: 'Grenada', translationKey: 'COUNTRY_GD' },
    { code: 'GP', name: 'Guadeloupe', translationKey: 'COUNTRY_GP' },
    { code: 'GU', name: 'Guam', translationKey: 'COUNTRY_GU' },
    { code: 'GT', name: 'Guatemala', translationKey: 'COUNTRY_GT' },
    { code: 'GG', name: 'Guernsey', translationKey: 'COUNTRY_GG' },
    { code: 'GN', name: 'Guinea', translationKey: 'COUNTRY_GN' },
    { code: 'GW', name: 'Guinea-Bissau', translationKey: 'COUNTRY_GW' },
    { code: 'GY', name: 'Guyana', translationKey: 'COUNTRY_GY' },
    { code: 'HT', name: 'Haiti', translationKey: 'COUNTRY_HT' },
    { code: 'HK', name: 'Hong Kong', translationKey: 'COUNTRY_HK' },
    { code: 'HU', name: 'Hungary', translationKey: 'COUNTRY_HU' },
    { code: 'IS', name: 'Iceland', translationKey: 'COUNTRY_IS' },
    { code: 'IN', name: 'India', translationKey: 'COUNTRY_IN' },
    { code: 'ID', name: 'Indonesia', translationKey: 'COUNTRY_ID' },
    { code: 'IR', name: 'Iran', translationKey: 'COUNTRY_IR' },
    { code: 'IQ', name: 'Iraq', translationKey: 'COUNTRY_IQ' },
    { code: 'IE', name: 'Ireland', translationKey: 'COUNTRY_IE' },
    { code: 'IM', name: 'Isle of Man', translationKey: 'COUNTRY_IM' },
    { code: 'IL', name: 'Israel', translationKey: 'COUNTRY_IL' },
    { code: 'IT', name: 'Italy', translationKey: 'COUNTRY_IT' },
    { code: 'CI', name: 'Ivory Coast', translationKey: 'COUNTRY_CI' },
    { code: 'JM', name: 'Jamaica', translationKey: 'COUNTRY_JM' },
    { code: 'JP', name: 'Japan', translationKey: 'COUNTRY_JP' },
    { code: 'JE', name: 'Jersey', translationKey: 'COUNTRY_JE' },
    { code: 'JO', name: 'Jordan', translationKey: 'COUNTRY_JO' },
    { code: 'KZ', name: 'Kazakhstan', translationKey: 'COUNTRY_KZ' },
    { code: 'KE', name: 'Kenya', translationKey: 'COUNTRY_KE' },
    { code: 'KI', name: 'Kiribati', translationKey: 'COUNTRY_KI' },
    { code: 'KP', name: 'Korea (North)', translationKey: 'COUNTRY_KP' },
    { code: 'KR', name: 'Korea (South)', translationKey: 'COUNTRY_KR' },
    { code: 'KW', name: 'Kuwait', translationKey: 'COUNTRY_KW' },
    { code: 'KG', name: 'Kyrgyzstan', translationKey: 'COUNTRY_KG' },
    { code: 'LA', name: 'Laos', translationKey: 'COUNTRY_LA' },
    { code: 'LV', name: 'Latvia', translationKey: 'COUNTRY_LV' },
    { code: 'LB', name: 'Lebanon', translationKey: 'COUNTRY_LB' },
    { code: 'LS', name: 'Lesotho', translationKey: 'COUNTRY_LS' },
    { code: 'LR', name: 'Liberia', translationKey: 'COUNTRY_LR' },
    { code: 'LY', name: 'Libya', translationKey: 'COUNTRY_LY' },
    { code: 'LI', name: 'Liechtenstein', translationKey: 'COUNTRY_LI' },
    { code: 'LT', name: 'Lithuania', translationKey: 'COUNTRY_LT' },
    { code: 'LU', name: 'Luxembourg', translationKey: 'COUNTRY_LU' },
    { code: 'MO', name: 'Macau', translationKey: 'COUNTRY_MO' },
    { code: 'MK', name: 'Macedonia', translationKey: 'COUNTRY_MK' },
    { code: 'MG', name: 'Madagascar', translationKey: 'COUNTRY_MG' },
    { code: 'MW', name: 'Malawi', translationKey: 'COUNTRY_MW' },
    { code: 'MY', name: 'Malaysia', translationKey: 'COUNTRY_MY' },
    { code: 'MV', name: 'Maldives', translationKey: 'COUNTRY_MV' },
    { code: 'ML', name: 'Mali', translationKey: 'COUNTRY_ML' },
    { code: 'MT', name: 'Malta', translationKey: 'COUNTRY_MT' },
    { code: 'MH', name: 'Marshall Islands', translationKey: 'COUNTRY_MH' },
    { code: 'MQ', name: 'Martinique', translationKey: 'COUNTRY_MQ' },
    { code: 'MR', name: 'Mauritania', translationKey: 'COUNTRY_MR' },
    { code: 'MU', name: 'Mauritius', translationKey: 'COUNTRY_MU' },
    { code: 'YT', name: 'Mayotte', translationKey: 'COUNTRY_YT' },
    { code: 'MX', name: 'Mexico', translationKey: 'COUNTRY_MX' },
    { code: 'FM', name: 'Micronesia', translationKey: 'COUNTRY_FM' },
    { code: 'MD', name: 'Moldova', translationKey: 'COUNTRY_MD' },
    { code: 'MC', name: 'Monaco', translationKey: 'COUNTRY_MC' },
    { code: 'MN', name: 'Mongolia', translationKey: 'COUNTRY_MN' },
    { code: 'ME', name: 'Montenegro', translationKey: 'COUNTRY_ME' },
    { code: 'MA', name: 'Morocco', translationKey: 'COUNTRY_MA' },
    { code: 'MZ', name: 'Mozambique', translationKey: 'COUNTRY_MZ' },
    { code: 'MM', name: 'Myanmar', translationKey: 'COUNTRY_MM' },
    { code: 'NA', name: 'Namibia', translationKey: 'COUNTRY_NA' },
    { code: 'NR', name: 'Nauru', translationKey: 'COUNTRY_NR' },
    { code: 'NP', name: 'Nepal', translationKey: 'COUNTRY_NP' },
    { code: 'NL', name: 'Netherlands', translationKey: 'COUNTRY_NL' },
    { code: 'NC', name: 'New Caledonia', translationKey: 'COUNTRY_NC' },
    { code: 'NZ', name: 'New Zealand', translationKey: 'COUNTRY_NZ' },
    { code: 'NI', name: 'Nicaragua', translationKey: 'COUNTRY_NI' },
    { code: 'NE', name: 'Niger', translationKey: 'COUNTRY_NE' },
    { code: 'NG', name: 'Nigeria', translationKey: 'COUNTRY_NG' },
    { code: 'NU', name: 'Niue', translationKey: 'COUNTRY_NU' },
    { code: 'NF', name: 'Norfolk Island', translationKey: 'COUNTRY_NF' },
    { code: 'MP', name: 'Northern Mariana Islands', translationKey: 'COUNTRY_MP' },
    { code: 'NO', name: 'Norway', translationKey: 'COUNTRY_NO' },
    { code: 'OM', name: 'Oman', translationKey: 'COUNTRY_OM' },
    { code: 'PK', name: 'Pakistan', translationKey: 'COUNTRY_PK' },
    { code: 'PW', name: 'Palau', translationKey: 'COUNTRY_PW' },
    { code: 'PS', name: 'Palestine', translationKey: 'COUNTRY_PS' },
    { code: 'PA', name: 'Panama', translationKey: 'COUNTRY_PA' },
    { code: 'PG', name: 'Papua New Guinea', translationKey: 'COUNTRY_PG' },
    { code: 'PY', name: 'Paraguay', translationKey: 'COUNTRY_PY' },
    { code: 'PE', name: 'Peru', translationKey: 'COUNTRY_PE' },
    { code: 'PH', name: 'Philippines', translationKey: 'COUNTRY_PH' },
    { code: 'PN', name: 'Pitcairn', translationKey: 'COUNTRY_PN' },
    { code: 'PL', name: 'Poland', translationKey: 'COUNTRY_PL' },
    { code: 'PT', name: 'Portugal', translationKey: 'COUNTRY_PT' },
    { code: 'PR', name: 'Puerto Rico', translationKey: 'COUNTRY_PR' },
    { code: 'QA', name: 'Qatar', translationKey: 'COUNTRY_QA' },
    { code: 'RE', name: 'Reunion', translationKey: 'COUNTRY_RE' },
    { code: 'RO', name: 'Romania', translationKey: 'COUNTRY_RO' },
    { code: 'RU', name: 'Russia', translationKey: 'COUNTRY_RU' },
    { code: 'RW', name: 'Rwanda', translationKey: 'COUNTRY_RW' },
    { code: 'SH', name: 'Saint Helena', translationKey: 'COUNTRY_SH' },
    { code: 'KN', name: 'Saint Kitts and Nevis', translationKey: 'COUNTRY_KN' },
    { code: 'LC', name: 'Saint Lucia', translationKey: 'COUNTRY_LC' },
    { code: 'PM', name: 'Saint Pierre and Miquelon', translationKey: 'COUNTRY_PM' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines', translationKey: 'COUNTRY_VC' },
    { code: 'WS', name: 'Samoa', translationKey: 'COUNTRY_WS' },
    { code: 'SM', name: 'San Marino', translationKey: 'COUNTRY_SM' },
    { code: 'ST', name: 'Sao Tome and Principe', translationKey: 'COUNTRY_ST' },
    { code: 'SA', name: 'Saudi Arabia', translationKey: 'COUNTRY_SA' },
    { code: 'SN', name: 'Senegal', translationKey: 'COUNTRY_SN' },
    { code: 'RS', name: 'Serbia', translationKey: 'COUNTRY_RS' },
    { code: 'SC', name: 'Seychelles', translationKey: 'COUNTRY_SC' },
    { code: 'SL', name: 'Sierra Leone', translationKey: 'COUNTRY_SL' },
    { code: 'SG', name: 'Singapore', translationKey: 'COUNTRY_SG' },
    { code: 'SK', name: 'Slovakia', translationKey: 'COUNTRY_SK' },
    { code: 'SI', name: 'Slovenia', translationKey: 'COUNTRY_SI' },
    { code: 'SB', name: 'Solomon Islands', translationKey: 'COUNTRY_SB' },
    { code: 'SO', name: 'Somalia', translationKey: 'COUNTRY_SO' },
    { code: 'ZA', name: 'South Africa', translationKey: 'COUNTRY_ZA' },
    { code: 'GS', name: 'South Georgia and South Sandwich Islands', translationKey: 'COUNTRY_GS' },
    { code: 'ES', name: 'Spain', translationKey: 'COUNTRY_ES' },
    { code: 'LK', name: 'Sri Lanka', translationKey: 'COUNTRY_LK' },
    { code: 'SD', name: 'Sudan', translationKey: 'COUNTRY_SD' },
    { code: 'SR', name: 'Suriname', translationKey: 'COUNTRY_SR' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen', translationKey: 'COUNTRY_SJ' },
    { code: 'SZ', name: 'Swaziland', translationKey: 'COUNTRY_SZ' },
    { code: 'SE', name: 'Sweden', translationKey: 'COUNTRY_SE' },
    { code: 'CH', name: 'Switzerland', translationKey: 'COUNTRY_CH' },
    { code: 'SY', name: 'Syria', translationKey: 'COUNTRY_SY' },
    { code: 'TW', name: 'Taiwan', translationKey: 'COUNTRY_TW' },
    { code: 'TJ', name: 'Tajikistan', translationKey: 'COUNTRY_TJ' },
    { code: 'TZ', name: 'Tanzania', translationKey: 'COUNTRY_TZ' },
    { code: 'TH', name: 'Thailand', translationKey: 'COUNTRY_TH' },
    { code: 'TG', name: 'Togo', translationKey: 'COUNTRY_TG' },
    { code: 'TK', name: 'Tokelau', translationKey: 'COUNTRY_TK' },
    { code: 'TO', name: 'Tonga', translationKey: 'COUNTRY_TO' },
    { code: 'TT', name: 'Trinidad and Tobago', translationKey: 'COUNTRY_TT' },
    { code: 'TN', name: 'Tunisia', translationKey: 'COUNTRY_TN' },
    { code: 'TR', name: 'Turkey', translationKey: 'COUNTRY_TR' },
    { code: 'TM', name: 'Turkmenistan', translationKey: 'COUNTRY_TM' },
    { code: 'TC', name: 'Turks and Caicos Islands', translationKey: 'COUNTRY_TC' },
    { code: 'TV', name: 'Tuvalu', translationKey: 'COUNTRY_TV' },
    { code: 'VI', name: 'U.S. Virgin Islands', translationKey: 'COUNTRY_VI' },
    { code: 'UG', name: 'Uganda', translationKey: 'COUNTRY_UG' },
    { code: 'UA', name: 'Ukraine', translationKey: 'COUNTRY_UA' },
    { code: 'AE', name: 'United Arab Emirates', translationKey: 'COUNTRY_AE' },
    { code: 'GB', name: 'United Kingdom', translationKey: 'COUNTRY_GB' },
    { code: 'US', name: 'USA', translationKey: 'COUNTRY_US' },
    { code: 'UY', name: 'Uruguay', translationKey: 'COUNTRY_UY' },
    { code: 'UZ', name: 'Uzbekistan', translationKey: 'COUNTRY_UZ' },
    { code: 'VU', name: 'Vanuatu', translationKey: 'COUNTRY_VU' },
    { code: 'VA', name: 'Vatican City', translationKey: 'COUNTRY_VA' },
    { code: 'VE', name: 'Venezuela', translationKey: 'COUNTRY_VE' },
    { code: 'VN', name: 'Vietnam', translationKey: 'COUNTRY_VN' },
    { code: 'WF', name: 'Wallis and Futuna', translationKey: 'COUNTRY_WF' },
    { code: 'EH', name: 'Western Sahara', translationKey: 'COUNTRY_EH' },
    { code: 'YE', name: 'Yemen', translationKey: 'COUNTRY_YE' },
    { code: 'ZM', name: 'Zambia', translationKey: 'COUNTRY_ZM' },
    { code: 'ZW', name: 'Zimbabwe', translationKey: 'COUNTRY_ZW' },
];

/**
 * Country codes that should NOT be selectable in country dropdowns
 * (restricted / sanctioned / high-risk countries).
 * Note: an already-saved customer with one of these countries will still
 * display it correctly — only the selectable option list is filtered.
 */
export const RESTRICTED_COUNTRY_CODES: string[] = [
    'KP', // North Korea / Nordkorea
    'IR', // Iran
    'MM', // Myanmar
    'RU', // Russia / Ryssland
    'SY', // Syria / Syrien
    'AF', // Afghanistan
    'DZ', // Algeria / Algeriet
    'AO', // Angola
    'BO', // Bolivia
    'VG', // British Virgin Islands
    'CM', // Cameroon / Kamerun
    'CI', // Ivory Coast / Elfenbenskusten
    'CD', // DR Congo / DR Kongo
    'HT', // Haiti
    'KE', // Kenya
    'LA', // Laos
    'LB', // Lebanon / Libanon
    'ML', // Mali
    'MC', // Monaco
    'NA', // Namibia
    'NP', // Nepal
    'SS', // South Sudan / Sydsudan
    'TT', // Trinidad and Tobago
    'VU', // Vanuatu
    'VE', // Venezuela
    'VN', // Vietnam
    'YE', // Yemen / Jemen
];

/**
 * Get all countries sorted by name
 * @returns Array of countries sorted alphabetically by name
 */
export const getCountries = (): Country[] => {
    return [...COUNTRIES].sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Get country name by code
 * @param code - Country code (e.g., 'US', 'SE')
 * @returns Country name or empty string if not found
 */
export const getCountryName = (code: string): string => {
    const country = COUNTRIES.find(c => c.code === code);
    return country?.name || '';
};

/**
 * Get country code by name
 * @param name - Country name (e.g., 'USA', 'Sweden')
 * @returns Country code or empty string if not found
 */
export const getCountryCode = (name: string): string => {
    const country = COUNTRIES.find(c => c.name === name);
    return country?.code || '';
};

/**
 * Get translation key for a country by name
 * @param name - Country name (e.g., 'USA', 'Sweden')
 * @returns Translation key for i18n or empty string if not found
 */
export const getCountryTranslationKey = (name: string): string => {
    const country = COUNTRIES.find(c => c.name === name);
    return country?.translationKey || '';
};

/**
 * Render countries as JSX options for select dropdown
 * Used in onboarding and profile settings
 * @param selectedValue - The currently selected country value
 * @returns Array of JSX option elements
 */
export const renderCountryOptions = (selectedValue: string , t: (key: string) => string) => {
    const countries = getCountries();
    return countries.map((country) => (
        <option key={country.code} value={country.name}>
            {country.name}
        </option>
    ));
};

/**
 * Render countries as JSX options for select dropdown with i18n translation
 * Used in profile settings and other components that need translated country names
 * @param t - Translation function from react-i18next
 * @returns Array of JSX option elements with translated country names
 */
export const renderCountryOptionsWithI18n = (t: (key: string) => string) => {
    const countries = getCountries();
    return countries.map((country) => (
        <option key={country.code} value={country.name}>
            {t(country.translationKey) || country.name}
        </option>
    ));
};

/**
 * Validate if a country exists in the list
 * @param countryName - Country name to validate
 * @returns Boolean indicating if country exists
 */
export const isValidCountry = (countryName: string): boolean => {
    return COUNTRIES.some(c => c.name === countryName);
};
